import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import DashboardHistoryStore from 'stores/dashboard/DashboardHistoryStore';
import ArrowBackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import {browserHistory} from 'react-router';
import classNames from 'classnames';
import './DashboardBackButton.styl';
import {HISTORY_ACTIONS} from 'components/StatsPage2.utils';

class DashboardBackButton extends React.PureComponent {
  static getStores() {
    return [DashboardHistoryStore];
  }

  static getPropsFromStores() {
    const historyStore = DashboardHistoryStore.getState();
    return {
      history: historyStore.history,
    };
  }

  onClick(lastPath) {
    browserHistory.push({
      pathname: lastPath,
      state: {
        pathname: lastPath,
        action: HISTORY_ACTIONS.POP,
      },
    });
  }

  render() {
    const {history} = this.props;
    if (!history || history.isEmpty()) {
      return null;
    }
    const lastPath = history.last();
    if (!lastPath) {
      console.warn('Null path stored in dashboard history');
      return null;
    }
    const isCoach = lastPath.indexOf('/coach/') >= 0;
    const isManager = lastPath.indexOf('/manager/') >= 0;
    const backTo = isCoach ? 'Coach' : isManager ? 'Manager' : 'Exec';
    const parentClass = isCoach ? 'coach' : isManager ? 'manager' : 'exec';
    return (
      <div
        onClick={() => this.onClick(lastPath)}
        className={classNames('dashboard-back-button', parentClass)}>
        <ArrowBackIcon className={classNames('arrow', parentClass)} />
        <div className={classNames('label', parentClass)}>Back to {backTo}</div>
      </div>
    );
  }
}

export default connectToStores(DashboardBackButton);
